module.exports = __webpack_public_path__ + "static/img/011.b79bb10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/datav-yongdong/011.png
// module id = iF4m
// module chunks = 1